export default __webpack_public_path__ + "static/media/fret_ferret_logo.5ca39d8b.png";